import { ErrorResponse } from '@src/interface/api/response.interface'
import { getCompanyChallengeCategories } from '@src/lib/api/challenge'
import { CompanyChallengeCategoryDto } from '@src/type/challenge'
import { useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'

export function useGetCompanyChallengeCategoriesQuery() {
	const useQueryResult = useQuery<
		CompanyChallengeCategoryDto[],
		AxiosError<ErrorResponse>,
		CompanyChallengeCategoryDto[],
		[string]
	>(['getCompanyChallengeCategories'], getCompanyChallengeCategories)

	return useQueryResult
}
